import React from 'react';
import agra from '../../images/agrafr2.png';
import beneo from '../../images/beneo3.png';
import euroma from '../../images/euroma2.png';
import farm from '../../images/farmfr2.png';
import frigemo from '../../images/frigemo2.png';
import golden from '../../images/golden2.png';
import klaas from '../../images/klspl2.png';
import vreugde from '../../images/vrhil2.png';
import wagen from '../../images/wuniv2.png';
import nizo from '../../images/nizo.png';

import * as S from './styled';

const Carousel = () => {

  
  return (

    <S.Slider>
      <S.SliderTrack>        

        <S.Slide>
          <img src={golden} alt="" height=""/>
        </S.Slide>

        <S.Slide>
          <img src={vreugde} alt="" height=""/>
        </S.Slide>

        <S.Slide>
          <img src={euroma} alt="" height=""/>
        </S.Slide>

        <S.Slide>
          <img src={wagen} alt="" height=""/>
        </S.Slide>

        <S.Slide>
          <img src={agra} alt="" height=""/>
        </S.Slide>

        <S.Slide>
          <img src={beneo} alt="" height=""/>
        </S.Slide>

        <S.Slide>
          <img src={farm} alt="" height="" />
        </S.Slide>

        <S.Slide>
          <img src={klaas} alt="" height=""/>
        </S.Slide>

        <S.Slide>
          <img src={frigemo} alt="" height=""/>
        </S.Slide>
        
        <S.Slide>
          <img src={nizo} alt="" height=""/>
        </S.Slide>

        <S.Slide>
          <img src={golden} alt="" height=""/>
        </S.Slide>

        <S.Slide>
          <img src={vreugde} alt="" height=""/>
        </S.Slide>

        <S.Slide>
          <img src={euroma} alt="" height=""/>
        </S.Slide>

        <S.Slide>
          <img src={wagen} alt="" height=""/>
        </S.Slide>

        <S.Slide>
          <img src={agra} alt="" height=""/>
        </S.Slide>

        <S.Slide>
          <img src={beneo} alt="" height=""/>
        </S.Slide>

        <S.Slide>
          <img src={farm} alt="" height="" />
        </S.Slide>

        <S.Slide>
          <img src={klaas} alt="" height=""/>
        </S.Slide>

        <S.Slide>
          <img src={frigemo} alt="" height=""/>
        </S.Slide>

        <S.Slide>
          <img src={nizo} alt="" height=""/>
        </S.Slide>


      </S.SliderTrack>
    </S.Slider>

  );
};

export default Carousel;

// const clients = [golden, vreugde, euroma, wagen, agra, beneo, farm, klaas, frigemo, nizo, golden, vreugde, euroma, wagen, agra, beneo, farm, klaas, frigemo, nizo];